import $ from 'jquery';

export const updateMiniCart = data => {
    const newMiniCart = $(data);
    const count = newMiniCart.data('minicart-count');
    $(".MiniCart").html($(newMiniCart).html());
    $('.Header-toggleCart > div').text(count);
    
    const miniCartListing = $(".MiniCart .MiniCart-products");
    const height = miniCartListing[0].scrollHeight;
    miniCartListing.scrollTop(height);
}

export const emptyMiniCart = data => {
    const newMiniCart = $(data);
    const count = newMiniCart.data('minicart-count');
    $(".MiniCart").html($(newMiniCart).html());
    $('.Header-toggleCart > div').text(count);
}

export default () => {

    $(document).on('click', '[data-add-ajax]', function(e) {
        e.preventDefault();
        let $article = $(this)

        let data = {
            view: 'product',
            product_id: $article.data('productId'),
            thelia_cart_add: {
                append: 1,
                success_url: window.gcbGlobal.url.cart,
                product: $article.data('productId'),
                product_sale_elements_id: $article.data('pseId'),
                quantity: $article.data('quantity')
            }
        };

        $.ajax({type: "POST", data: data, url: window.gcbGlobal.url.cartAdd,
            success: function(data){
                updateMiniCart(data);
                $(document).trigger("CloseProductModal");
            },
            error: function (e) {
                console.log('Error.', e);
            }
        });
    })

    $(document).on('change', '.form-product-update',  function(e) {
        const form = $(this);
        const url = form.attr('action');
        const quantity = parseInt(form.find('input[name="quantity"]').val(), 10);
        const cart_item = form.find('input[name="cart_item"]').val();
        
        if (quantity <= 0) {
            $.ajax({
                type: 'GET',
                url: form.data('delete-url'),
                success: updateMiniCart
            })
        } else {
            $.ajax({type: "POST", data: { quantity, cart_item }, url,
                success: updateMiniCart,
                error: function (e) {
                    console.log('Error.', e);
                }
            });
        }
    })

    $(document).on('click.form-product-update', '.form-product-update button, .form-product-update a' , function(e) {
        e.preventDefault();
        const type = $(this).data('qty');
        const form = $(this).parents('form');
        const url = form.attr('action');
        const quantityInput = form.find('input[name="quantity"]');
        let quantity = parseInt(quantityInput.val(), 10);

        const quantityStep = +quantityInput.attr('step') || 100;
        const quantityMin = +quantityInput.attr('min') || 100;
        const quantityMax = +quantityInput.attr('max') || 5000;
        

        const cart_item = form.find('input[name="cart_item"]').val();
    
        if (!type) return;

        switch (type) {
            case 'minus':
                if ((quantity - quantityStep) < quantityMin) {
                    quantity = quantityMin    
                } else {
                    quantity = quantity - quantityStep
                }
                break;
            case 'plus':
                if ((quantity + quantityStep) > quantityMax) {
                    quantity = quantityMax;
                } else {
                    quantity = quantity + quantityStep
                }
                break;        
            case 'delete':
                $.ajax({
                    type: 'GET',
                    url: $(this).attr('href'),
                    success: updateMiniCart
                })
                return
                break;
            default:
                break;
        }
        

        $.ajax({type: "POST", data: { quantity, cart_item }, url,
            success: function(data){
                updateMiniCart(data);
                
                $(document).trigger( "CloseProductModal" );
            },
            error: function (e) {
                console.log('Error.', e);
            }
        });

        return false;
    })

    $(document).on('click', '.MiniCart-footer-delete a', function(e) {
        e.preventDefault();
        $.ajax({type: "GET", url: $(this).attr('href'),
            success: function(data){
                emptyMiniCart(data);
            },
            error: function (e) {
                console.log('Error.', e);
            }
        });
        return false;        
    })
}


// WEBPACK FOOTER //
// ./assets/src/js/modules/SubmitAddCart.js